export class PinCredentials {
	diaryId: string;
	pin: string;
}
